import { useEffect } from "react";
import { Toaster, toast } from "@jana-technology/platform-ui";

export type HierarchyIdToasterProps = {
  selectedHierarchyIdsLength: number;
  submitDisabled: boolean;
  children: React.ReactNode;
};

export const HierarchyIdToaster = ({
  selectedHierarchyIdsLength,
  submitDisabled,
  children,
}: HierarchyIdToasterProps) => {
  useEffect(() => {
    if (selectedHierarchyIdsLength && submitDisabled) {
      // toast needs a timer and a close method to prevent multiple toasts from stacking up
      toast.warning("Please select at least one field");
    }
  }, [selectedHierarchyIdsLength, submitDisabled]);

  return (
    <>
      {children}
      <Toaster />
    </>
  );
};
